/* tslint:disable */

/**
 */
export class ActivityLogSearchFrom {
    company_id?: number;
    from_date?: string;
    to_date?: string;
}
